import React, { useContext, useState } from 'react';
import {
  Button,
  Card, Col, Form, Nav, ProgressBar, Row,
} from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFlag, faLock, faUser, faThumbsUp, faChevronLeft, faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import WizardModal from '../blanks/wizard/WizardModal';
import IconButton from '../blanks/common/IconButton';
import Success from '../blanks/wizard/Success';
import PersonalForm from './getAccount/PersonalForm';
import DescriptionForm from './getAccount/DescriptionForm';
import AuthLogikaForm from './getAccount/AuthLogikaForm';
import api from '../../api/req';
import { LogicaContext } from '../../providers';
import Loader from '../bootStrap/loader';
import IconAlert from '../blanks/common/IconAlert';
import Section from '../blanks/common/Section';

const stepItems = [
  {
    icon: faFlag,
    label: 'Почнемо',
  },
  {
    icon: faLock,
    label: 'Авторизація',
  },
  {
    icon: faUser,
    label: 'Реєстрація',
  },
  {
    icon: faThumbsUp,
    label: 'Є!',
  },
];

const sendEmail = async (user) => {
  const email = user.changeDataByForm?.EMail;
  const r = await api.post$('/api/auth-dj/users/reset_password/', () => null, { email });
  if (r.ok) {
    return true;
  }
  return false;
};

// eslint-disable-next-line consistent-return
const validateUser = async (user) => {
  const r = await api.post$('/api/auth/validate_user/', () => null, { ...user });

  if (r.ok) {
    return { success: true };
  }

  if (r.status === 403) {
    const res = await r.json();
    return res;
  }
};

const creatProfile = async (user, ticket) => {
  if (user) {
    const response = await api.post$('/api/auth/createProfile/', () => null, {
      ...user,
      ticket,
      // eslint-disable-next-line consistent-return
    });

    if (response.ok) {
      return { success: true };
    }
    if ((response.status === 400) || (response.status === 403)) {
      const res = await response.json();
      return { success: false, error: JSON.stringify(res.error) };
    }

    // await api.post$('/api/logica/save-to-log/', () => null, {
    //   create_profile: {
    //     ...user,
    //     ticket,
    //   },
    // });

    return {
      success: false,
      error: 'Сталася помилка під час створення облікового запису. Зверніться до лінії консультацій.',
    };
  }
  return { success: false, error: 'Відсутні дані щодо користувача' };
};

function Error({ error, setError }) {
  const [show, setShow] = useState(true);

  if (show) {
    return (
      <IconAlert
        variant="danger"
        dismissible
        onClose={() => {
          setError(false);
          setShow(false);
        }}
      >
        <p className="mb-0">{error}</p>
      </IconAlert>
    );
  }
  return <Button className="mb-3 me-3" onClick={() => setShow(true)}>Показати помилку</Button>;
}

Error.propTypes = {
  error: PropTypes.string,
  setError: PropTypes.func.isRequired,
};

Error.defaultProps = {
  error: 'Помилка',
};

function WizardLayout() {
  const [user, setUser] = useState({ changeDataByForm: { EMail: '' } });
  const [step, setStep] = useState(1);
  const [successLogica, setSuccessLogica] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    reset,
    clearErrors,
  } = useForm();

  const [modal, setModal] = useState(false);
  const { ticket } = useContext(LogicaContext);

  const onSubmitData = (data) => {
    setUser({ ...user, ...data });
    if (successLogica || (step < 2)) {
      // setStep(step + 1);
      if (step + 1 === 4) {
        setLoading(true);
        setError(false);
        validateUser(user).then((validate) => {
          if (validate.success) {
            creatProfile(user, ticket).then((res) => {
              if (res.success) {
                sendEmail(user).then((r) => {
                  if (r) {
                    setStep(step + 1);
                  } else {
                    setError('Сталася помилка під час відправки листа-запрошення. Зверніться до лінії консультацій');
                  }
                });
              } else { setError(res.error); }
              setLoading(false);
            });
          } else {
            setLoading(false);
            setError(validate.error);
          }
        });
      } else {
        setStep(step + 1);
      }
    }
  };

  const onError = () => {
    // if (!validation) {
    clearErrors();
    if (step + 1 === 4) {
      creatProfile(user, ticket).then((res) => {
        if (res) {
          setStep(step + 1);
        }
      });
    } else {
      setStep(step + 1);
    }
  };

  const toggle = () => setModal(!modal);

  const handleNavs = (targetStep) => {
    if (step !== 4) {
      if (targetStep < step) {
        setStep(targetStep);
      } else {
        handleSubmit(onSubmitData, onError)();
      }
    } else {
      toggle();
    }
  };

  return (
    <>
      <WizardModal modal={modal} setModal={setModal} />
      <Card
        as={Form}
        noValidate
        onSubmit={handleSubmit(onSubmitData, onError)}
        className="theme-wizard mb-5"
      >
        <Card.Header
          className={classNames('bg-light', {
            'px-4 py-3': false,
            'pb-2': true,
          })}
        >
          <Nav className="justify-content-center">
            {' '}
            {stepItems.map((item, index) => (
              <NavItem
                key={item.label}
                index={index + 1}
                step={step}
                handleNavs={handleNavs}
                icon={item.icon}
                label={item.label}
              />
            ))}
          </Nav>
        </Card.Header>
        <ProgressBar now={step * 25} style={{ height: 2 }} />
        {error && (
        <Error error={error} setError={setError} />
        )}
        <Card.Body className="fw-normal py-4" style={{ padding: '0' }}>
          {step === 1 && (
            <DescriptionForm register={register} watch={watch} />
          )}
          {step === 2 && (
            <AuthLogikaForm
              register={register}
              errors={errors}
              setUser={setUser}
              setSuccessLogica={setSuccessLogica}
            />
          )}
          {step === 3 && (
            <PersonalForm
              register={register}
              errors={errors}
              setValue={setValue}
              setUser={setUser}
              user={user}
            />
          )}
          {step === 4 && (
          <Success reset={reset} setStep={setStep} setUser={setUser} />
          )}
        </Card.Body>
        <Card.Footer
          className={classNames('bg-light', {
            'd-none': step === 4,
            ' d-flex': step < 4,
          })}
        >
          <IconButton
            variant="link"
            icon={faChevronLeft}
            iconAlign="left"
            transform="down-1 shrink-4"
            className={classNames('px-0 fw-semi-bold', {
              'd-none': step === 1,
            })}
            onClick={() => {
              setStep(step - 1);
            }}
          >
            Повернутись
          </IconButton>

          {(successLogica || (step < 2)) && (
          <IconButton
            variant="primary"
            className="ms-auto px-5"
            type="submit"
            icon={faChevronRight}
            iconAlign="right"
            transform="down-1 shrink-4"
          >
            Далі
          </IconButton>
          )}
          {loading && (
          <Loader />
          )}
        </Card.Footer>
      </Card>
    </>
  );
}

function NavItem({
  index, step, handleNavs, icon, label,
}) {
  return (
    <Nav.Item>
      <Nav.Link
        className={classNames('fw-semi-bold', {
          done: index < 4 ? step > index : step > 3,
          active: step === index,
        })}
        onClick={() => handleNavs(index)}
      >
        <span className="nav-item-circle-parent">
          <span className="nav-item-circle">
            <FontAwesomeIcon icon={icon} />
          </span>
        </span>
        <span className="d-none d-md-block mt-1 fs--1">{label}</span>
      </Nav.Link>
    </Nav.Item>
  );
}

function DontHavePassword() {
  return (
    <Section fluid className="py-0">
      <Row className="g-0 min-vh-100 flex-center">
        <Col lg={8} xxl={5} className="py-3 position-relative">
          <Card className="h-100">
            <Card.Header className="d-md-flex justify-content-center border-bottom border-200 py-3 py-md-2">
              <h3 className="mb-0 text-info"> Створення облікового запису "Є-Пічник"</h3>
            </Card.Header>
            <Card.Body className="scrollbar overflow-y-hidden">
              <WizardLayout />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
}

NavItem.propTypes = {
  index: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  handleNavs: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default DontHavePassword;
